import { NoiseEvent } from 'app/business-logic/services/noise-service';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { NoiseEventTableData } from './EventsListing.types';
import { useEventHistoryWeatherData } from './useEventHistoryWeatherData';

export const useEventHistoryTableData = ({ data }: { data: NoiseEvent[] | undefined }) => {
  const weatherData = useEventHistoryWeatherData({
    data,
  });
  const tableData: NoiseEventTableData[] = useMemo(() => {
    return (
      data?.map(event => {
        const targetMillis = DateTime.fromISO(event.startTime ?? '').toMillis();
        return {
          ...event,
          windSpeed: {
            value: findClosestValue(weatherData.windSpeed.data, targetMillis),
            displayUnit: weatherData.windSpeed.displayUnit,
          },
          windDirection: {
            value: findClosestValue(weatherData.windDirection.data, targetMillis),
            displayUnit: weatherData.windDirection.displayUnit,
          },
          rainfall: {
            value: findClosestValue(weatherData.rainfall.data, targetMillis),
            displayUnit: weatherData.rainfall.displayUnit,
          },
        };
      }) ?? []
    );
  }, [data, weatherData]);
  return {
    tableData,
  };
};

const findClosestValue = (
  data: [number, (number | undefined)?, (number | undefined)?][] | undefined,
  targetMillis: number
): number | undefined => {
  return data?.reduce(
    (closest, current) => {
      const [currentTime] = current;
      if (!closest) return current;
      const [closestTime] = closest;
      return Math.abs(currentTime - targetMillis) < Math.abs(closestTime - targetMillis) ? current : closest;
    },
    undefined as [number, (number | undefined)?, (number | undefined)?] | undefined
  )?.[1];
};
